import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyle = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            wrapper: css({
                padding: `0 ${theme.orbitalThree}`,
                borderBottomColor: theme.palette.stroke.default,

                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
            }),
            breadcrumbsStyle: css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }),
            trailingStyle: css({
                display: 'flex',
                alignItems: 'center',
                gap: theme.orbitalFour,
            }),

            mobileHeader: css({
                background: theme.palette.background.container,
                borderBottom: `1px solid ${theme.palette.stroke.default}`,
                display: 'flex',
                justifyContent: 'space-between',
                padding: `${theme.orbitalThree} ${theme.orbitalFour}`,
            }),
        }),
        [theme.orbitalFour, theme.orbitalThree, theme.palette.background.container, theme.palette.stroke.default]
    );
};

export default useStyle;
